import { jsx } from 'react/jsx-runtime';
import { NotificationActive, Notification as Notification$1 } from '@dls/assets/icons';
import '../../../../../../authentication/context/AuthenticationProvider.js';
import '@geit/ui-components';
import 'react';
import { useCurrentUser } from '../../../../../../authentication/hooks/useCurrentUser.js';
import 'qs';
import 'uuid';
import '../../../../../../authentication/navigate.js';
import theme from '../../../../theme/index.js';
import HeaderAdditionalControlItem from '../HeaderAdditionalControlItem/index.js';
const Notification = _ref => {
  let {
    url = "/account/notifications",
    theme: theme$1,
    onClick
  } = _ref;
  const {
    user
  } = useCurrentUser();
  return /* @__PURE__ */jsx(HeaderAdditionalControlItem, {
    href: url,
    onClick,
    ariaLabel: "Notifications",
    children: user.notificationUnreadCount > 0 ? /* @__PURE__ */jsx(NotificationActive, {
      size: 24,
      color: theme$1 === "dark" ? theme.colours.white : theme.colours.black
    }) : /* @__PURE__ */jsx(Notification$1, {
      size: 24,
      color: theme$1 === "dark" ? theme.colours.white : theme.colours.black
    })
  });
};
export { Notification as default };